/* eslint-disable no-unreachable */
import Cloud from "../../infra/Cloud.js";
import * as Util from "../../infra/Util";
import * as fetchsGeral from "../worker/endpoints.js";
import { generatePath } from "react-router";


export function setStory(data) {
  return {
    type: "SET_STORY",
    data,
  };
}


export function setSuspectSelected(data) {
  return {
    type: "SET_SUSPECT_SELECTED",
    data,
  };
}

export function setActionSelected(data) {
  return {
    type: "SET_ACTION_SELECTED",
    data,
  };
}

export function setUser(user) {
  setTimeout(() => {
    saveAsync("user", user);
  }, 10);
  Cloud.setTokenUser(user.token_user);
  return {
    type: "SET_USER",
    user,
  };
}

export function logout(callback) {
  saveAsync("empresa", null);
  saveAsync("user", null);
  Cloud.setTokenUser("");
  Cloud.setTokenEmpresa("");
  if (callback)
    return callback(
      {
        type: "LOGOUT",
        user: null,
        empresa: null,
      },
      null
    );
}

export function loadAsyncUser(callback) {
  /*
  AsyncStorage.getItem("user", (err, result) => {
    if (result) {
      try {
        var ret = JSON.parse(result);
        ret = ret ? ret : null;
        if (ret && ret.token_user)
          Cloud.setTokenUser(ret.token_user);
        if (callback) return callback(ret, null);
      } catch (e) {
        if (callback) return callback(null, null);
      }
    } else {
      if (callback) return callback(null, null);
    }
  });*/
}

export function loadAsyncEmpresa(callback) {
  /*
  AsyncStorage.getItem("empresa", (err, result) => {
    if (result) {
      try {
        var ret = JSON.parse(result);
        ret = ret ? ret : null;
        if (ret && ret.token)
          Cloud.setTokenEmpresa(ret.token);
        if (callback) return callback(ret, null);
      } catch (e) {
        if (callback) return callback(null, null);
      }
    } else {
      if (callback) return callback(null, null);
    }
  });
  */
}

export function saveAsync(nomeobj, obj) {
  /*
  try {
    AsyncStorage.setItem(nomeobj, JSON.stringify(obj));
  } catch (e) {
    console.log(e);
  }
    */
}

export function tabsTelas(componente) {
  var { tela } = componente.props.match.params;
  var { tabs } = componente;

  for (let index = 0; index < tabs.length; index++) {
    let element = tabs[index];
    if (tela == element.tela) {
      return element.index;
    }
  }
}

export function pushToTab({ index, componente, path }) {
  var { history } = componente.props;
  var { tabs } = componente;
  let tela = "";
  for (let a = 0; a < tabs.length; a++) {
    let element = tabs[a];
    if (index == element.index) {
      tela = element.tela;
      break;
    }
  }
  history.replace({
    pathname: "/" + path + "/" + tela,
  });
}

export function getUrlsObj({ empresa, history, match }) {
  let { params } = match;
  let obj = {};
  if (empresa) {
    obj.pathEmpresa = "/filial/" + empresa.id_filial + "/empresa/" + empresa._id;
  }
  obj.url = match.url + "";
  obj.path = match.path + "";
  for (const [key, value] of Object.entries(params)) {
    obj[key] = value;
  }
  obj.history = Util.clone(history);
  obj.getAteXPath = (pathindex) => {
    let urlquebrado = obj.url.split("/");
    urlquebrado = urlquebrado.slice(0, pathindex);
    urlquebrado = urlquebrado.join("/");
    return urlquebrado;
  };
  obj.updateUrl = (paramsEnviado, componente) => {
    history.replace({ pathname: generatePath(obj.path, { ...params, ...paramsEnviado }) });
    if (componente.objpath) {
      componente.objpath = getUrlsObj(componente.props);
    }
    // else if (componente.state.objpath) {//qem sabe com callback ou set set state mesmo, por enquanto nao foi preciso.
    //   componente.state.objpath = getUrlsObj(componente.props)
    // }

    return true;
  };
  // console.log("getUrlsObj", obj);
  return obj;
}
